import { InjectionToken } from '@angular/core';

/**
 * Injection token for the API base URL. Each app provides this in its
 * `app.config.ts` from its own `environment.apiBaseUrl` — the shared
 * lib stays environment-agnostic so it works for both the internal
 * + portal apps without duplication.
 *
 * Per EBT/9 §"API conventions", the canonical base is `/api/v1` (or
 * `/api/v1/portal` for the portal surface).
 */
export const API_BASE_URL = new InjectionToken<string>('EBT_API_BASE_URL');
